import {
  Card,
  Stack,
  Button,
  Container,
  Typography,
  Box,
  Tabs,
  Tab,
} from "@mui/material";

import { useEffect, useState } from "react";

import axios from "axios";
import { Editor } from "react-draft-wysiwyg";
import "../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import {
  EditorState,
  convertToRaw,
  convertFromRaw,
  ContentState,
} from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import Iconify from "../../components/iconify";

const isOlybet = process.env.REACT_APP_NAME === 'olybet';

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 1, paddingTop: 3 }}>{children}</Box>}
    </div>
  );
}

const defaultContent = {
  content_en: EditorState.createEmpty(),
  content_es: EditorState.createEmpty(),
  content_fr: EditorState.createEmpty(),
  content_lv: EditorState.createEmpty(),
  content_lt: EditorState.createEmpty(),
  content_nl: EditorState.createEmpty(),
  content_rus: EditorState.createEmpty(),
  content_sl: EditorState.createEmpty(),
  content_esp: EditorState.createEmpty(),
  content_de: EditorState.createEmpty(),
};
const languages = ["en", "es", "fr", "lv", "lt", "nl", "rus", "sl", "esp", "de"];
const PickemRulesEdit = (props) => {
  const { pickemId } = props;
  const [value, setValue] = useState(0);
  const [pageId, setPageId] = useState(null);
  const [state, setState] = useState(defaultContent);
  useEffect(() => {
    console.log("pickemId", pickemId);
    axios
      .get(
        `${process.env.REACT_APP_API_BASE_URL}/admin/pages/key/pickem-${pickemId}`
      )
      .then(function (response) {
        let state = defaultContent;
        if (response.data.page !== null) {
          setPageId(response.data.page.page_id);
          for (let lang of languages) {
            const html = response.data.page[`content_${lang}`];
            const contentBlock = htmlToDraft(html);
            if (contentBlock) {
              const contentState = ContentState.createFromBlockArray(
                contentBlock.contentBlocks
              );
              state[`content_${lang}`] =
                EditorState.createWithContent(contentState);
            }
          }
        }

        setState({ ...state });
      });
  }, []);
  const handleChangeTabs = (event, newValue) => {
    setValue(newValue);
  };
  const handleChange = (event, lang) => {
    setState((prevState) => ({
      ...prevState,
      [`content_${lang}`]: event,
    }));
  };
  const saveHandler = () => {
    let page = {};
    for (let lang of languages) {
      page[`content_${lang}`] = draftToHtml(
        convertToRaw(state[`content_${lang}`].getCurrentContent())
      );
    }
    page.page_key = `pickem-${pickemId}`;
    if (pageId === null) {
      axios
        .post(`${process.env.REACT_APP_API_BASE_URL}/admin/pages/`, page)
        .then((response) => {
          window.location.reload(false);
        });
    } else {
      axios
        .put(
          `${process.env.REACT_APP_API_BASE_URL}/admin/pages/${pageId}`,
          page
        )
        .then((response) => {
          window.location.reload(false);
        });
    }
  };
  return (
    <Container>
      <Stack direction="row" alignItems="right" mb={5}>
        <Button
          variant="contained"
          startIcon={<Iconify icon="eva:save-outline" />}
          onClick={() => saveHandler()}
          sx={{ mr: 2 }}
        >
          Save
        </Button>
      </Stack>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChangeTabs}
          aria-label="basic tabs example"
        >
          <Tab label="English" {...a11yProps(0)} />
          <Tab label="French" {...a11yProps(1)} />
          <Tab label="Slovak" {...a11yProps(2)} />
          <Tab label="Estonian" {...a11yProps(3)} />
          <Tab label="Latvian" {...a11yProps(4)} />
          <Tab label="Lithuanian" {...a11yProps(5)} />
          <Tab label="Russian" {...a11yProps(6)} />
          {!isOlybet && <Tab label="Spanish" {...a11yProps(7)} />}
          {!isOlybet && <Tab label="German" {...a11yProps(8)} />}
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <Card sx={{ p: 2 }}>
          <Editor
            editorState={state.content_en}
            onEditorStateChange={(e) => handleChange(e, "en")}
          />
        </Card>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Card sx={{ p: 2 }}>
          <Editor
            editorState={state.content_fr}
            onEditorStateChange={(e) => handleChange(e, "fr")}
          />
        </Card>
      </TabPanel>
      <TabPanel value={value} index={2}>
        <Card sx={{ p: 2 }}>
          <Editor
            editorState={state.content_sl}
            onEditorStateChange={(e) => handleChange(e, "sl")}
          />
        </Card>
      </TabPanel>
      <TabPanel value={value} index={3}>
        <Card sx={{ p: 2 }}>
          <Editor
            editorState={state.content_es}
            onEditorStateChange={(e) => handleChange(e, "es")}
          />
        </Card>
      </TabPanel>
      <TabPanel value={value} index={4}>
        <Card sx={{ p: 2 }}>
          <Editor
            editorState={state.content_lv}
            onEditorStateChange={(e) => handleChange(e, "lv")}
          />
        </Card>
      </TabPanel>
      <TabPanel value={value} index={5}>
        <Card sx={{ p: 2 }}>
          <Editor
            editorState={state.content_lt}
            onEditorStateChange={(e) => handleChange(e, "lt")}
          />
        </Card>
      </TabPanel>
      <TabPanel value={value} index={6}>
        <Card sx={{ p: 2 }}>
          <Editor
            editorState={state.content_rus}
            onEditorStateChange={(e) => handleChange(e, "rus")}
          />
        </Card>
      </TabPanel>
      <TabPanel value={value} index={7}>
        <Card sx={{ p: 2 }}>
          <Editor
            editorState={state.content_esp}
            onEditorStateChange={(e) => handleChange(e, "esp")}
          />
        </Card>
      </TabPanel>
      <TabPanel value={value} index={8}>
        <Card sx={{ p: 2 }}>
          <Editor
            editorState={state.content_de}
            onEditorStateChange={(e) => handleChange(e, "de")}
          />
        </Card>
      </TabPanel>
    </Container>
  );
};
export default PickemRulesEdit;
